<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize">
            <el-form-item label="批次ID">
                <el-input v-model="formInline.ticketBatchId" placeholder="批次ID"></el-input>
            </el-form-item>
            <el-form-item label="批次名称">
                <el-input v-model="formInline.ticketBatchName" placeholder="批次名称"></el-input>
            </el-form-item>
            <el-form-item label="优惠劵类型">
                <el-select v-model="formInline.createType" clearable filterable>
                    <el-option
                            v-for="item in cashCreateTypeEnum"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            
            <el-form-item label="折扣类型">
                <el-select v-model="formInline.discountMode" clearable filterable>
                    <el-option
                            v-for="item in cashDiscountModeEnum"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <!--<el-button-group>-->
                    <el-button type="success" @click="getList">查询</el-button>
                    <el-button type="primary" @click="handleUpdate({ticketBatchId:0})">新增批次</el-button>
                    <el-button type="success" style="display: none;" @click="setCashCache4Old">设置优惠券码缓存</el-button>
                    <el-button type="primary" @click="importYouShu" v-show="false">同步有数</el-button>
                <!--</el-button-group>-->
            </el-form-item>
        </el-form>
        <el-table :data="getCashticketBatchList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="ticketBatchId" label="批次ID"></el-table-column>
            <el-table-column prop="ticketBatchName" label="批次名称"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" sortable></el-table-column>
            <el-table-column prop="createTypeName" label="类型"></el-table-column>
            <el-table-column prop="ticetClassName" label="分类"></el-table-column>
            <el-table-column prop="discountModeName" label="折扣"></el-table-column>
            <el-table-column prop="discountOrAmount" label="金额/比例" sortable></el-table-column>
            <el-table-column prop="minUseamount" label="最低使用金额" sortable></el-table-column>
            <el-table-column prop="quantity" label="兑换/发送次数" sortable></el-table-column>
            <el-table-column prop="alreadyQuantity" label="已领取" sortable></el-table-column>
            <el-table-column prop="userTackCount" label="每人最多领取" sortable></el-table-column>
            <el-table-column :formatter="convertStatus" label="状态"></el-table-column>
          <!--  <el-table-column :formatter="convertVisible" label="可见"></el-table-column>-->
         <!--   <el-table-column :formatter="convertCashType" label="券号类型"></el-table-column>-->
            <el-table-column prop="userName" label="创建人"></el-table-column>
            <el-table-column prop="cashComposeUseName" label="叠加使用"></el-table-column>
           <!-- <el-table-column prop="remark" label="备注"></el-table-column>-->
            <el-table-column label="操作" fixed="right" width="200">
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button type="warning" size="mini" @click="handleUpdate(scope.row)">修改</el-button>
                        <el-button type="info" size="mini" v-if="scope.row.status==1" @click="handledDelete(scope.row)">禁用</el-button>
                    </el-button-group>
                   </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {
        getCashticketBatchList,
        getQueryList,
        deleteCashticketBatch,
        importCoupon,
        setCashCache,
    } from '../../api/api'

    //定义组件
    export default {
        data() {
            return {
                getCashticketBatchList: [],
                cashCreateTypeEnum: [],
                cashDiscountModeEnum: [],
                cashApplyToEnum: [],
                loading: true,
                form: {
                    ticketBatchId: '',
                    ticketBatchName: '',
                    ticketType: 0,
                    createType: 3,
                    ticketPosition: 7,
                    minUseamount:0,
                    quantity: 100,
                    discountMode:0,
                    discountAmount: 100,
                    amount: 0,
                    periodType: 2,
                    days: 7,
                    userTackCount: 1,
                    remark: '',
                    status: 1,
                    ticetClass: '',
                    ticketNoNum: 1,
                    userVisible: 1,
                    digital: 1,
                    cashUseUrl:'',
                    beginTime:'',
                    endTime:'',
                    composeUse:0
                },
                formInline: {
                    ticketBatchId: "",
                    ticketBatchName: "",
                    createType: "",
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0,
                },
            }
        },
        //挂载时候执行
        mounted() {
            //获取查询条件下拉列表
            getQueryList({}).then((res) => {
                this.cashCreateTypeEnum = res.data.value.cashCreateTypeEnum;
                this.cashCreateTypeEnum.pop();
                this.cashDiscountModeEnum = res.data.value.cashDiscountModeEnum;
                this.cashApplyToEnum = res.data.value.cashApplyToEnum;
                this.getList();
            });
        },
        methods: {
            //定义查询方法
            getList() {
                this.loading = true;
                getCashticketBatchList(this.formInline).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '查询成功',
                            type: 'success'
                        });
                        this.formInline.recordsTotal = res.data.value.total;
                        this.getCashticketBatchList = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            importYouShu(){
                this.loading = true;
                this.$message({
                    showClose: true,
                    message: '导入有数比较费时，请耐心等待',
                    type: 'success'
                });
                importCoupon({platformGroupId:1000}).then((res) => {
                })
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            handleUpdate(row) {
                this.$router.push({name: 'CashBathDetail',params:{id:row.ticketBatchId},query:{cashId:row.ticketBatchId}})
            },
            handledDelete(row) {
                this.$confirm('禁用优惠劵批次, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const loading = this.$loading(this.GCONFIG.loadingParam);
                    deleteCashticketBatch({ticketBatchId: row.ticketBatchId}).then((res) => {
                        loading.close();
                        if (res.data.status == 200) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList();
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {
                });
            },
            convertStatus(row, column, cellValue) {
                if (row.status == 1) {
                    return "启用";
                } else {
                    return "禁用";
                }
            },
            convertVisible(row, column, cellValue) {
                if (row.userVisible == 1) {
                    return "可见";
                } else {
                    return "不可见";
                }
            },
            convertCashType(row, column, cellValue) {
                if (row.digital == 1) {
                    return "数字";
                } else {
                    return "字母混合";
                }
            },
            setCashCache4Old(){
                setCashCache().then((res) => {});
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/cash/cashBath.vue